import React, { Component } from "react";
import diagram from "../../images/EnergyDiagram3.svg";
import axios from "axios";
import PointContainer from "./PointContainer";
import RemoteControlUI from "../remoteCtrlComponents/RemoteControlUI"

export default class RemoteControl extends Component {
  state = {
    // pointsSchema: [],
    // mqttMessages: [],
  };

  login = () => {
    this.props.auth.login();
  };
  // calls the logout method in authentication service
  logout = () => {
    this.props.auth.logout();
  };

  componentDidMount() {}

  componentDidUpdate() {}

  render() {
    const { isAuthenticated } = this.props.auth;
    return (
      <div className="main-content">
      <h3 className="heading">Energy cycle</h3>
      <div className="loop-container-loop">
        <div className="loop-container">
          <div className="loop-wrapper">
            {!isAuthenticated() && (
              <div className="container column">
                Unauthenticated!
              </div>
            )}
            {isAuthenticated() && (
            <div className="div-block">
              <RemoteControlUI
                info={this.props.pointsSchema}
                messages={this.props.messages}
              />
              <img src={diagram} alt="Diagram" className="diagram" />
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
    );
  }
}
